import cN from 'classnames';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import { Component, ReactNode } from 'react';
import { Tabs as ReactTabs, Tab, TabList, TabPanel, TabsProps } from 'react-tabs';
import { EventTrackingProps, trackEvent } from '../../services/Tracking';
import style from './style.m.less';

const propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            header: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
            panel: PropTypes.element,
            disabled: PropTypes.bool,
            trackingLabel: PropTypes.string,
        })
    ),
    classNames: PropTypes.shape({
        tabContainer: PropTypes.string,
        tabList: PropTypes.string,
        tab: PropTypes.string,
        panel: PropTypes.string,
    }),
    onSelect: PropTypes.func,
    selectedIndex: PropTypes.number,
    eventTracking: PropTypes.shape({
        category: PropTypes.string.isRequired,
        action: PropTypes.string,
    }),
};

export type TabType = {
    header: ReactNode;
    panel?: ReactNode;
    disabled?: boolean;
    trackingLabel?: string;
};

type Props = {
    tabs: TabType[];
    children?: ReactNode;
    classes?: string;
    classNames?: {
        tabContainer?: string;
        tabList?: string;
        tab?: string;
        panel?: string;
    };
    compact?: boolean;
    fullWidth?: boolean;
    selectedIndex?: number | string;
    onSelect?: TabsProps['onSelect'];
    eventTracking?: EventTrackingProps;
};

export default class Tabs extends Component<Props> {
    static propTypes = propTypes;

    render() {
        const {
            tabs,
            children,
            classes,
            classNames = {},
            compact,
            fullWidth,
            selectedIndex,
            onSelect,
            eventTracking,
        } = this.props;
        return (
            <ReactTabs
                selectedTabClassName={style.selected}
                disabledTabClassName={style.disabled}
                className={cN(style.container, classes, classNames.tabContainer, {
                    [style.compact]: compact,
                    [style.fullWidth]: fullWidth,
                })}
                onSelect={(index: number, last: number, event: Event) => {
                    if (eventTracking) {
                        trackEvent({ ...eventTracking, label: tabs[index].trackingLabel });
                    }
                    return onSelect?.(index, last, event);
                }}
                selectedIndex={selectedIndex !== undefined ? parseInt(String(selectedIndex)) : undefined}
            >
                <TabList className={cN(style.tabList, classNames.tabList)}>
                    {map(tabs, (tab, i) => (
                        <Tab key={i} className={cN(style.tab, classNames.tab)} disabled={tab.disabled}>
                            {tab.header}
                        </Tab>
                    ))}
                    {children ? <div className={style.tabOptions}>{children}</div> : null}
                </TabList>
                {map(tabs, (tab, i) => (
                    <TabPanel key={i} className={cN(style.tabPanel, classNames.panel)}>
                        {tab.panel}
                    </TabPanel>
                ))}
            </ReactTabs>
        );
    }
}
